import { Button, Divider } from "@shopify/polaris";
import styles from "../Volume.module.css";
import { useContext } from "react";
import { VolumeBundleContext } from "../VolumeDiscount";
import VolumeTargetingForm from "./VolumeTargetingForm";

const VolumeTargetForm = () => {
    const context = useContext(VolumeBundleContext);

    if (!context) return null;

    const { handleNext } = context;

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: "4px" }}>
                <Divider borderColor="border" />
            </div>
            <VolumeTargetingForm />

            <div className={styles.dividerStyle}>
                <Divider borderColor="border" />
            </div>
            <div className={styles.bottomRowCta}>
                <Button onClick={() => handleNext(1, "Design")}>Back</Button>
            </div>
        </div>
    );
};

export default VolumeTargetForm;
